import React from 'react';

// Palette deterministica in base al nome → colore stabile per utente.
const COLORS = [
  'bg-primary-600', 'bg-rose-500', 'bg-violet-600', 'bg-sky-600',
  'bg-emerald-600', 'bg-amber-500', 'bg-indigo-600', 'bg-teal-600',
];

function initials(name) {
  const parts = (name || '').trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
  return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
}

function colorFor(seed) {
  const s = seed || '';
  let hash = 0;
  for (let i = 0; i < s.length; i++) hash = (hash * 31 + s.charCodeAt(i)) >>> 0;
  return COLORS[hash % COLORS.length];
}

/**
 * Avatar con fallback a iniziali colorate.
 * - src: URL foto (se presente e caricabile); altrimenti iniziali.
 * - name: usato per iniziali + colore.
 * - size: classi Tailwind di dimensione (default w-12 h-12).
 * - textClass: dimensione testo iniziali.
 */
function Avatar({ src, name, seed, size = 'w-12 h-12', textClass = 'text-base', className = '' }) {
  const base = `rounded-full flex items-center justify-center text-white font-bold shrink-0 overflow-hidden ${size} ${className}`;

  if (src) {
    return (
      <div className={base}>
        <img src={src} alt={name || 'avatar'} className="w-full h-full object-cover" />
      </div>
    );
  }

  return (
    <div className={`${base} ${colorFor(seed || name)}`}>
      <span className={textClass}>{initials(name)}</span>
    </div>
  );
}

export default Avatar;
